import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CityLocationProvider } from './contexts/CityLocationContext';
import HlsTest from './HlsTest';

const params = new URLSearchParams(window.location.search);
const hls = params.get('hls');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  (hls === '1') ? (
    <HlsTest />
  ) : (
    <CityLocationProvider>
      <App />
    </CityLocationProvider>
  )
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
